(function () {
  // Redirect legacy blog URLs to the matching pages version.
  var path = window.location.pathname || '';

  // Avoid redirect loops if already on the target pages.
  var isOnEnGamesPage = path === '/pages/en-games' || path.startsWith('/pages/en-games/');
  var isOnGamesPage = path === '/pages/games' || path.startsWith('/pages/games/');

  function redirect(targetBase) {
    var search = window.location.search || '';
    var hash = window.location.hash || '';
    window.location.replace(targetBase + search + hash);
  }

  if (!isOnEnGamesPage && (path === '/blogs/en-games' || path.endsWith('/blogs/en-games'))) {
    redirect('/pages/en-games');
    return;
  }

  if (!isOnGamesPage && (path === '/blogs/games' || path.endsWith('/blogs/games'))) {
    redirect('/pages/games');
  }
})();
